import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BForm, BRow,
  BCol, BFormInput, BFormTextarea, BFormCheckbox, BFormGroup, BButton, BModal, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'

export const FormLayout = {
  name: 'FormLayout',
  mixins: [],
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormGroup,
    vSelect,
    BButton,
    BSpinner,
  },
  data() {
    return {
      createAbleFields: [],
      editAbleFields: [],
      required,
    }
  },
  computed: {

  },
}
export const EditFormLayoutMixin = {
  name: 'EditFormLayoutMixin',
  mixins: [FormLayout],
  data() {
    return {
      dateTimeFormat: 'YYYY-MM-DD HH:mm',
      submitSpinner: false,
      attachmentsForm: {
        attachments: [
          {
            file: null,
            progress: 0,
          },
        ],
      },
      useRouteName: false,
    }
  },
  computed: {
    isUpdated() {
      return this.form.id !== undefined
    },
  },
  methods: {
    onSubmit(bvModalEvent = null) {
      if (bvModalEvent) bvModalEvent.preventDefault()
      this.$refs.form.validate().then(success => {
        if (success) {
          const formData = {}
          let fields = this.createAbleFields
          let slug
          if (this.isUpdated || this.form.id) {
            slug = this.form.id
            if (this.editAbleFields.length !== 0) fields = this.editAbleFields
          }
          fields.forEach(field => {
            formData[field] = this.form[field]
          })
          // set spinner to submit button
          this.submitSpinner = true
          // send store request
          let request
          if (this.isUpdated) request = this.$http.put(`${this.routeName}/${slug}`, formData)
          else request = this.$http.post(this.routeName, formData)
          request
            .then(({ data, message }) => {
              if (message) this.showSuccessNotification(message)
              this.editFormSendSuccess(data)
            })
            .catch(() => {
              this.submitSpinner = false
              return this.editFormSendFails()
            })
        }
      })
    },
    editFormSendSuccess(data) {
      if (this.attachmentsForm.attachments[0].file) {
        this.attachmentsForm.attachments.forEach(
          async (attachment, index) => {
            await this.uploadAttachment(
              data.id,
              attachment.file,
              index,
            )
            if (
              index
                            === this.attachmentsForm.attachments.length - 1
            ) {
              this.emitData(data)
              this.submitSpinner = false
              return this.afterEditFormSendSuccess()
            }
          },
        )
        this.emitData(data)
        this.submitSpinner = false
        return this.afterEditFormSendSuccess()
      }
      this.emitData(data)
      this.submitSpinner = false
      return this.afterEditFormSendSuccess()
    },
    afterEditFormSendSuccess() {},
    emitData(data) {
      return this.$emit(
        this.isUpdated ? 'onItemUpdated' : 'onItemCreated',
        data,
      )
    },
    editFormSendFails() {},
    async uploadAttachment(id, file, index, routeName = null) {
      if (routeName === null) routeName = this.routeName
      const config = {
        onUploadProgress: progressEvent => {
          this.attachmentsForm.attachments[index].progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )
        },
      }

      const data = new FormData()
      data.append('file', file)
      return this.$http.post(
        `${routeName}/${id}/attachment`,
        data,
        config,
      )
    },
    hideModal() {
      return this.$emit('onHideModal')
    },
  },
}

export const EditModalMixin = {
  name: 'EditModalMixin',
  components: {
    BModal,
    BSpinner,
  },
  mixins: [],
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    additionalData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loader: true,
      modalName: '',
    }
  },
  computed: {},
  methods: {
    onSubmitModalForm() {
      // set spinner to submit button
      this.showSpinner()
      return this.$emit('onModalFormSend', this.form)
    },
    afterEditFormSendSuccess() {
      return this.$bvModal.hide(this.modalName)
    },
    hideModal() {
      this.loader = true
      return this.$emit('onHideModal')
    },
  },
}

export const _ = null
